<div class="facility-info content">
    <app-sprintpay-facility-information
        [disabledZoom]="true"
        [zoomCenterMarker]="9"
        [zoom]="zoom"
        [data]="facilityInformation"
        [initialIndex]="initialIndex"
    >
    </app-sprintpay-facility-information>
</div>
